import { memo } from "react";

const Bell = () => (
  <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_276_2937)">
      <path
        d="M15 6.75793C15 5.43185 14.4732 4.16008 13.5355 3.2224C12.5979 2.28472 11.3261 1.75793 10 1.75793C8.67392 1.75793 7.40215 2.28472 6.46447 3.2224C5.52678 4.16008 5 5.43185 5 6.75793C5 12.5913 2.5 14.2579 2.5 14.2579H17.5C17.5 14.2579 15 12.5913 15 6.75793Z"
        stroke="currentColor"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.4417 17.5913C11.2952 17.8439 11.0849 18.0535 10.8319 18.1993C10.5789 18.345 10.292 18.4217 10 18.4217C9.70803 18.4217 9.42117 18.345 9.16816 18.1993C8.91515 18.0535 8.70486 17.8439 8.55835 17.5913"
        stroke="currentColor"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_276_2937">
        <rect width="20" height="20" fill="white" transform="translate(0 0.0913086)" />
      </clipPath>
    </defs>
  </svg>
);

export default memo(Bell);
